import React, { useState, useRef, useEffect } from "react";
import { isMobile, MobileView } from "react-device-detect";
import Map from "../map";
import Popup from "reactjs-popup";
import { ButtonLoader } from "../../utils/ButtonLoader";
import { useWindowWidth } from "@react-hook/window-size";

if (!isMobile)
    import('./addressmap.css').then(() => {});
else
    import('./addressmap_mob.css').then(() => {});


export function FranceAddress({onAddressAdded=()=>{}})
{
    return(<Popup trigger={<input type="button" style={{padding:'10px 5px 5px 10px',fontSize:'x-small',backgroundColor:'skyblue',color:'black',border:'none',borderRadius:'5px'}} value={'Ajouter une Adresse'} />} position={"center center"}>
            { close=>(
                    <div id="MapDiv" style={{width:'100%',height:'100vh',position:'fixed',top:'0px'}}>
                        <fieldset style={{}}>
                            <div>
                                <label>Addresse : </label>
                                <input type="text" placeholder="Votre addresse complet" />
                            </div>
                            <input type="button" value={'OK'} />
                        </fieldset>
                        <a style={{}} className="closemap" onClick={close}>
                            &times;
                        </a>
                    </div>
            )}
            </Popup>);
}

function isInComoros(lat, lng) {
    const comorosBounds = {
    north: -11.2,  // northernmost point
    south: -13.1,  // southernmost point
    east: 44.6,    // easternmost point
    west: 43.1     // westernmost point
    };
    return (
    lat >= comorosBounds.south &&
    lat <= comorosBounds.north &&
    lng >= comorosBounds.west &&
    lng <= comorosBounds.east
    );
}

export function AddressMap({onAddressAdded = ()=>{}, locations, country='France', new_location_type='user_point',btn_text='Nouvelle Addresse'})
{
    const [new_location,setNewLocation] = useState({location:null,mode:'Votre position'});
    const [loading,setLoading] = useState(false);
    
    const [clearNewMark, setClearNewMark] = useState(false);
    const [infoText, setInfoText] = useState({color:'black',text:"Vous avez choisi d'ajouter automatiquement votre position à votre liste d'adresse. Indiquez nous un nom pour cet endroit, exemple"+'"Depot djamnazi"'+ 'puis cliquer sur valider.'})
    const screenWidth = useWindowWidth();

    let locs = [];
    locations.forEach(element => {
        if(element.country==='Comores')
            locs.push(element)
    });
    const [_locations, setLocations] = useState(locs);

    const SetAutoText=()=>{
        setInfoText({color:'black',
                    text:<div style={{marginTop:'10px'}}><ButtonLoader loading={true} style={{backGroundColor:'transparent'}} /></div>
                });
        navigator.geolocation.getCurrentPosition(
        async (pos) => {
            const { latitude, longitude } = pos.coords;
            if(!isInComoros(latitude,longitude))
            {setInfoText({color:'orangered',text:"Vous n'êtes pas aux comores, ce service est non disponible. Veuillez sélectionner un ajout manuel de votre addresse."});return;}
            var _location = {type:'user_point',coords:{latitude:latitude,longitude:longitude}};
            setNewLocation({...new_location,location:_location});
            const point = pos.coords;
            const nomination_url = 'https://nominatim.openstreetmap.org/reverse?format=json&lat='+point.latitude+'&lon='+point.longitude;
            await fetch(nomination_url,{method:'get'})
            .then((resp)=>{try{return resp.json()}catch{console.log("errorgetting position");}})
            .then((result)=>{
                if(!!result.display_name)
                {setInfoText({color:'green',
                    text:`Vous êtes localisé à : ${result.display_name}. Voulez vous utiliser ces coordonnées ?`
                });}
                else
                {setInfoText({color:'green',
                    text:`Vous êtes correctement localisé. Voulez vous utiliser ces coordonnées ?`
                });}
            });},
            (error)=>{console.log(error);setInfoText({color:'orangered',
                    text:`Nous n'avons pas reussi à vous localisé. le service est indisponible`
                });},
                  {
                    enableHighAccuracy: false, 
                    timeout: 10000,
                    maximumAge: 120000
                }
            );
    }

    useEffect(()=>{
        SetAutoText();
    },[])

    useEffect(()=>{    
        if(new_location.mode==='Votre position actuelle')
        {
            SetAutoText();
        }
        else
            setInfoText(({color:'black',text:"Veuillez choisir le point sur la carte correspondant à votre adress, ensuite donnez un label à votre adresse puis valider."}));
    },[new_location.mode])

    const NewLocationForm=(close)=>
    {
        return(
        <fieldset style={{backgroundColor:'rgba(255,255,255,0.5)'}} id="addLocationForm">
            <select style={{fontSize:'x-small',width:'100%',marginTop:'5px',textAlign:'center',height:'25px'}} onChange={e=>{setNewLocation({location:new_location.location,mode:e.target.value})}}>
                <option>Votre position actuelle</option>
                <option>Manuel</option>
            </select>
            <input style={{fontSize:'x-small',marginTop:'5px',textAlign:'center',width:'95%',height:'20px'}} placeholder="exp : Chez Asmina" onChange={e=>{setNewLocation({...new_location,location:{...new_location.location,label: e.target.value}})}} />
            <div style={{borderStyle:'none',position:'relative',textAlign:'center',marginTop:'5px',minHeight:"25px",width:'100%',borderRadius:'5px'}}>
                <div style={{width:'100%',height:'100%',display:'inline-block',marginRight:'5px',lineHeight:'80%'}}>
                    <div style={{height:'25px',width:'100%'}}>
                        <ButtonLoader onSubmit={e=>{ValidateNewLocation();}} loading={loading} style={{backGroundColor:'lightgreen'}} text={'Valider'}/>
                    </div>
                    <span style={{fontSize:'xx-small',color:infoText.color}}>
                        {infoText.text}
                    </span>
                </div>
                <MobileView style={{display:'inline-block',width:'100%'}}>
                    <input onClick={e=>{close()}} type="button" value={'Annuler'} style={{padding:'5px',width:'100%',backgroundColor:'#FFCBCC',border:'none',borderRadius:'5px'}} />
                </MobileView>
            </div>
        </fieldset>)
    }

    var ManualAddMarker = (point)=>
    {
        if(new_location.mode==='Manuel')
        {
            new_location.location = {...new_location.location,type:'new_point',coords:{latitude:point.latlng.lat,longitude:point.latlng.lng}};
            return {result:true,location:new_location.location};
        }
        else{
            return {result:false,location:{}};
        }
    }

    const AddNewPoint = async (point,loc)=>{

        if(!isInComoros(point.latitude,point.longitude))
        {
            setInfoText({color:'orangered',text:"Vous n'êtes pas aux comores, ce service est non disponible"});
            setLoading(false);
            return;
        }

        const nomination_url = 'https://nominatim.openstreetmap.org/reverse?format=json&lat='+point.latitude+'&lon='+point.longitude;
        await fetch(nomination_url,{method:'get'}).then((resp)=>{try{return resp.json()}catch{return -1}}).then((result)=>{
            if(result!==-1)
            {
                loc = {...loc,is_main:false};
                if(!!result.address.city)
                    loc = {...loc,ville:result.address.city}
                else if(!!result.address.village)
                    loc = {...loc,ville:result.address.village}
                if(!!result.address.state)
                    loc = {...loc,state:result.address.state}
                if(!!result.address.neighbourhood)
                    loc = {...loc,neighbourhood:result.address.neighbourhood}
                if(!!result.address.country)
                    loc = {...loc,country:result.address.country}
                if(!!result.display_name)
                    loc = {...loc,comment:result.display_name,display_name:result.display_name}
                else
                    loc = {...loc,comment:"",display_name:"inconnu"}
            }
            else
            {
                if(!!result.display_name)
                    loc = {...loc,comment:result.display_name,display_name:result.display_name}
                else
                    loc = {...loc,comment:"",display_name:"inconnu"}
            }
        }).catch(()=>{loc = {...loc,comment:"",display_name:"inconnu"}})
        var added = onAddressAdded(loc);
        if(added)
        {
            _locations.push(loc);
            setLocations([..._locations]);
            setNewLocation({...new_location,location:null});
            setClearNewMark(true);
            setInfoText({color:'green',text:"L'adresse a été ajouté avec succès à votre liste"});
        }
        else
        {
            const inf = infoText;
            setInfoText({text:"Vous ne pouvez pas ajouter plus de trois adresse à votre liste",color:'red'});
            setTimeout(()=>{setInfoText(inf);},10000);
        }
        setLoading(false);
    }

    const ValidateNewLocation=async()=>
    {
        setLoading(true);
        var loc = {};
        var point = {};
        if(new_location.mode ==='Manuel')
        {
            loc = {...new_location.location,type:'user_point',ville:"Inconnue",country:'Comores'}
            point = new_location.location.coords;
            AddNewPoint(point,loc);
        }
        else if(new_location.mode ==='Votre position actuelle')
        {
            navigator.geolocation.getCurrentPosition((position)=>{
                loc = {...new_location.location,type:'user_point',coords:{latitude:position.coords.latitude,longitude:position.coords.longitude}};
                point = {latitude:position.coords.latitude,longitude:position.coords.longitude};
                AddNewPoint(point,loc);
                },(error)=>{console.log("error");setLoading(false);setInfoText({color:'orangered',text:"Nous n'avons pas reussi à vous localisé. le service est indisponible"})},
                {enableHighAccuracy: false, 
                timeout: 10000,
                maximumAge: 120000
                });
        }
                    
    }

    const validateAddressFrace = ()=>{
        let loc = {...new_location.location,type:'user_point',ville:"Inconnue",country:'France',is_main:false}
        console.log(loc.label);
        if(!!loc.label)
            loc = {...loc,label:loc.label}
        else
            loc = {...loc,label:"Mon addresse"}
        const added = onAddressAdded(loc);
        if(added)
        {
            _locations.push(loc);
            setLocations(_locations);
            setNewLocation({...new_location,location:null});
        }
        else
        {
            const inf = infoText;
            setInfoText({text:"Vous ne pouvez pas ajouter plus de trois adresse à votre liste",color:'red'});
            setTimeout(()=>{setInfoText(inf);},10000);
        }
    }


    let alias_country = ' française';
    if(country==='Comores')
        alias_country = ' comorienne';


    //if(isMobile)
    //{
       return(
            <Popup trigger={<input type="button" style={{padding:'10px 30px 10px 30px',fontSize:'small',marginTop:'5px',width:'fit-content',backgroundColor:'skyblue',color:'black',border:'none',borderRadius:'5px'}} value={btn_text} />} position={"center center"}>
            { close=>(
                    <div id="screen" style={{width:'100%',height:'100vh',backgroundColor:'rgba(0,0,0,0.8)',position:'fixed',top:'0px',left:'0px'}}>
                        {   (country==='Comores') &&
                            <div id="MapDiv" style={{}}>
                                <div id="AddressMap">
                                    <Map OnAddMarker={ManualAddMarker} zoom={15} locations={_locations} />
                                </div>
                                <a className="closemap" onClick={close}>
                                    &times;
                                </a>
                                {NewLocationForm(close)}
                            </div>
                        }
                        {
                            (country==='France') &&
                            <div id="AdrressFrance">
                                <div style={{padding:'30px 0px 30px 0px'}}>
                                    <div>
                                        <label>Label :</label>
                                        <input onChange={e=>{setNewLocation({...new_location,location:{...new_location.location,label:e.target.value}})}} type="text" style={{height:'30px',width:'60%',marginLeft:'10px',textAlign:'center'}} defaultValue={'Mon addresse'} />
                                    </div>
                                    <div style={{marginTop:'5px'}}>
                                        <label>Addresse :</label>
                                        <input onChange={e=>{setNewLocation({...new_location,location:{...new_location.location,display_name:e.target.value}})}} type="text" style={{height:'30px',width:'60%',marginLeft:'10px',textAlign:'center'}} placeholder="Votre addresse" />
                                    </div>
                                    <input onClick={e=>{validateAddressFrace();close();}} type="button" value={"Enregistrer"} style={{height:'40px',border:'none',backgroundColor:'lightblue',width:'35%',borderRadius:'5px',marginTop:'10px'}} />
                                    <a style={{}} className="closemap" onClick={close}>
                                        &times;
                                    </a>  
                                </div>
                            </div>
                        }
                    </div>
            )}
            </Popup>);
    //}
    
    //else
    //{
    /*    return(
        <div id="AddressMap" style={{height:'400px',width:'100%',position:'relative'}}>
            <Map clearNewMark={clearNewMark} setClearNewMark={setClearNewMark} OnAddMarker={ManualAddMarker} zoom={15} locations={_locations}  />
            {NewLocationForm()}
        </div>) 
    }*/
    
}

